import formMapper from "@mappers/Modules/award/AwardItem.mapper";
import createItemAPI from "@services/Award/createAward";
import Create from "@shared/FormTemplates/Create";
import validator from "@validators/Modules/award/award.validate";
import { ReactElement } from "react";
import CreateForm from "./CreateForm";

const CreateItem = (): ReactElement => (
  <Create
    CustomForm={CreateForm}
    createHook={createItemAPI}
    validator={validator}
    formMapper={formMapper}
  />
);

export default CreateItem;
